import React from 'react';
import AppGlobals from "../../common/AppGlobals";
import HTML from '../../common/HtmlHelpers';
import PropTypes from 'prop-types';

class PlatformContainer extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            isMobile: AppGlobals.get('isMobile')
        };
    }

    renderWithFrame(){
        return <div>

            <div className="card-header">
                <div className="clearfix">
                    <div className="pull-left">
                        {HTML.renderIcon(this.props.icon)} {this.props.title}
                    </div>
                </div>
            </div>

            <div className="card-block">
                {this.props.renderHead ? this.props.renderHead() : null}
                {this.props.children}
            </div>

        </div>
    }

    renderNoFrame(){

        return  <div className="card-block" style={{padding: '25px'}}>
            {this.props.renderHead ? this.props.renderHead() : null}
            {this.props.children}
        </div>;

    }

    render(){

        const props = this.props;
        const hasFrame = (props.noFrame != true);

        return <div className={ hasFrame ?  "container-fluid" : ""}>
            <div className="animated fadeIn">
                <div className="row">
                    <div className="col-lg-12">
                        <div className={( hasFrame ?  "content-frame" : "")}>
                            <div className="card">
                                {hasFrame ? this.renderWithFrame() : this.renderNoFrame()}
                                {this.props.renderFooter ? this.props.renderFooter() : null}
                                {this.props.renderError ? this.props.renderError() : null}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

    }

}

PlatformContainer.propTypes = {
    renderHead: PropTypes.func,
    renderFooter: PropTypes.func,
    renderError: PropTypes.func,
    icon: PropTypes.string,
    title: PropTypes.string,
    noFrame: PropTypes.bool
};

export default  PlatformContainer;


// WEBPACK FOOTER //
// ./src/components/PlatformContainer/PlatformContainer.js